import HttpService from "./HttpService";
const API_ENDPOINT = "/employee-salary-edit";

const EmployeeSalaryService = {
  async getSalaryInformation(id) {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default EmployeeSalaryService;
